import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import List from 'components/list/List';
import ListBody from 'components/list/ListBody';
import { Card, CardBody } from 'components/card';
import Message from 'components/message/Message';
import MessageText from 'components/message/MessageText';
import { useUIDSeed } from 'react-uid';
import ExerciseListItemSortable from 'containers/partials/list-items/ExerciseListItemSortable';
import { EditableContextProvider } from 'contexts/EditableContext';
import classNames from 'classnames';
import RefactoredListBody from 'components/list/RefactoredListBody';

const ExercisesListSortable = ({
  activeId,
  exercises = [],
  exerciseGroup,
  onClick,
  draggable,
  checkable,
  enablePreviewModal,
  onPreview,
  onSelect,
  selectedExercises,
  extraClassNames = {},
  showTemplateCount,
  showNote,
  showFrequency,
  showHasComment,
  noteType,
  editableNotes
}) => {
  const parentRef = useRef();
  const uidSeed = useUIDSeed();

  const onSelectHandler = (exercise, checked) => {
    onSelect && onSelect(exercise, checked);
  };

  return (
    <>
      {exercises.length > 0 ? (
        <EditableContextProvider>
          <List
            ref={parentRef}
            extraClassNames={classNames([
              'r-list--refactoring-wrapping-notes',
              extraClassNames
            ])}
            dragNDrop={draggable}
          >
            <RefactoredListBody>
              {exercises.map(exercise => {
                return (
                  <ExerciseListItemSortable
                    id={exercise.id}
                    key={exercise.id}
                    uid={uidSeed(exercise.id)}
                    exercise={exercise}
                    exerciseGroup={exerciseGroup}
                    notes={exerciseGroup?.notes?.[exercise.id]}
                    active={exercise.id === activeId}
                    showTemplateCount={showTemplateCount}
                    showNote={showNote}
                    showFrequency={showFrequency}
                    showHasComment={showHasComment}
                    noteType={noteType}
                    editableNote={editableNotes}
                    visible={selectedExercises.length > 0 && checkable}
                    clickable
                    checkable={checkable}
                    draggable={draggable}
                    checked={selectedExercises.find(e => e.id === exercise.id)}
                    onShowPreview={() =>
                      enablePreviewModal && onPreview(exercise)
                    }
                    onChange={e => onSelectHandler(exercise, e)}
                    onClick={() =>
                      enablePreviewModal
                        ? onPreview(exercise)
                        : onClick && onClick(exercise.id)
                    }
                  />
                );
              })}
            </RefactoredListBody>
          </List>
        </EditableContextProvider>
      ) : (
        <Card centered>
          <CardBody empty>
            <Message emptyState={true} icon="cursor">
              <MessageText>
                <FormattedMessage {...messages.exercisesListEmpty} />
              </MessageText>
            </Message>
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default ExercisesListSortable;
